import dateFns from 'date-fns/locale/id';

export default {
  dateFns,

  format: {
    date: 'dd MMM yyyy',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'd MMM',
    longDateTime: "d MMMM 'pada' p",
    fullDate: 'd MMM, y',
    fullDateTime: "d MMM, y 'pada' p",
  },

  translation: {
    common: {
      aboutPlanka: 'Tentang Planka',
      account: 'Akun',
      actions: 'Tindakan',
      addAttachment_title: 'Tambah Lampiran',
      addComment: 'Tambahkan komentar',
      addManager_title: 'Tambahkan Manager',
      addMember_title: 'Tambahkan Anggota',
      addUser_title: 'Tambahkan Pengguna',
      administrator: 'Administrator',
      all: 'Semua',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'Semua perubahan akan disimpan<br />setelah koneksi pulih.',
      areYouSureYouWantToDeleteThisAttachment: 'Apakah anda ingin menghapus lampiran ini?',
      areYouSureYouWantToDeleteThisBoard: 'Apakah anda ingin menghapus papan ini?',
      areYouSureYouWantToDeleteThisCard: 'Apakah anda ingin menghapus kartu ini?',
      areYouSureYouWantToDeleteThisComment: 'Apakah anda ingin menghapus komentar ini?',
      areYouSureYouWantToDeleteThisLabel: 'Apakah anda ingin menghapus label ini?',
      areYouSureYouWantToDeleteThisList: 'Apakah anda ingin menghapus daftar ini?',
      areYouSureYouWantToDeleteThisProject: 'Apakah anda ingin menghapus proyek ini?',
      areYouSureYouWantToDeleteThisTask: 'Apakah anda ingin menghapus tugas ini?',
      areYouSureYouWantToDeleteThisUser: 'Apakah anda ingin menghapus pengguna ini?',
      areYouSureYouWantToLeaveBoard: 'Apakah anda ingin keluar dari papan ini?',
      areYouSureYouWantToLeaveProject: 'Apakah anda ingin keluar dari proyek ini?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Apakah anda ingin menghapus manajer ini dari papan ini?',
      areYouSureYouWantToRemoveThisMemberFromBoard:
        'Apakah anda ingin menghapus anggota ini dari papan ini?',
      attachment: 'Lampiran',
      attachments: 'Lampiran-lampiran',
      authentication: 'Autentikasi',
      background: 'Latar belakang',
      board: 'Papan',
      boardNotFound_title: 'Papan Tidak Ditemukan',
      canComment: 'Bisa berkomentar',
      canEditContentOfBoard: 'Bisa mengubah isi papan.',
      canOnlyViewBoard: 'Hanya dapat menglihat isi papan.',
      cardActions_title: 'Aksi Kartu',
      cardNotFound_title: 'Kartu Tidak Ditemukan',
      cardOrActionAreDeleted: 'Kartu atau aksi telah dihapus.',
      color: 'Warna',
      createBoard_title: 'Buat Papan',
      createLabel_title: 'Buat Label',
      createNewOneOrSelectExistingOne: 'Create a new one or select<br />an existing one.',
      createProject_title: 'Buat Proyek',
      createTextFile_title: 'Buat Berkas Teks',
      currentPassword: 'Kata sandi sekarang',
      dangerZone_title: 'Zona Berbahaya',
      date: 'Tanggal',
      dueDate_title: 'Tenggat Waktu',
      deleteAttachment_title: 'Hapus Lampiran',
      deleteBoard_title: 'Hapus Papan',
      deleteCard_title: 'Hapus Kartu',
      deleteComment_title: 'Hapus Komentar',
      deleteLabel_title: 'Hapus Label',
      deleteList_title: 'Hapus Daftar',
      deleteProject_title: 'Hapus Proyek',
      deleteTask_title: 'Hapus Tugas',
      deleteUser_title: 'Hapus Pengguna',
      description: 'Deskripsi',
      detectAutomatically: 'Deteksi otomatis',
      dropFileToUpload: 'Tarik berkas untuk menggungah',
      editor: 'Pengubah',
      editAttachment_title: 'Ubah Lampiran',
      editAvatar_title: 'Ubah Avatar',
      editBoard_title: 'Ubah Papan',
      editDueDate_title: 'Ubah Tenggat Waktu',
      editEmail_title: 'Ubah E-mail',
      editInformation_title: 'Ubah Informasi',
      editLabel_title: 'Ubah Label',
      editPassword_title: 'Ubah Kata Sandi',
      editPermissions_title: 'Ubah Izin',
      editStopwatch_title: 'Ubah Stopwatch',
      editUsername_title: 'Ubah Username',
      email: 'E-mail',
      emailAlreadyInUse: 'E-mail telah digunakan',
      enterCardTitle: 'Masukkan judul kartu... [Ctrl+Enter] untuk membuka otomatis.',
      enterDescription: 'Masukkan deskripsi...',
      enterFilename: 'Masukkan nama berkas...',
      enterListTitle: 'Masukkan judul daftar...',
      enterProjectTitle: 'Masukkan judul proyek',
      enterTaskDescription: 'Masukkan deskripsi tugas...',
      filterByLabels_title: 'Saring berdasarkan Label',
      filterByMembers_title: 'Saring berdasarkan Anggota',
      fromComputer_title: 'Dari Komputer',
      fromTrello: 'Dari Trello',
      general: 'Umum',
      hours: 'Jam',
      importBoard_title: 'Impor Papan',
      invalidCurrentPassword: 'Kata sandi saat ini tidak valid',
      labels: 'Label',
      language: 'Bahasa',
      leaveBoard_title: 'Keluar dari Papan',
      leaveProject_title: 'Keluar dari Proyek',
      list: 'Daftar',
      listActions_title: 'Aksi Daftar',
      managers: 'Manager',
      members: 'Anggota',
      minutes: 'Menit',
      moveCard_title: 'Pindahkan Kartu',
      name: 'Nama',
      newEmail: 'E-mail baru',
      newPassword: 'Kata sandi baru',
      newUsername: 'Username baru',
      noConnectionToServer: 'Tidak ada koneksi ke server',
      noBoards: 'Tidak ada papan',
      noLists: 'Tidak ada daftar',
      noProjects: 'Tidak ada projek',
      notifications: 'Notifikasi',
      noUnreadNotifications: 'Tiada notifikasi yang belum dibaca.',
      openBoard_title: 'Buka Papan',
      optional_inline: 'opsional',
      organization: 'Organisasi',
      phone: 'Ponsel',
      preferences: 'Preferensi',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Tip: tekan Ctrl-V (Cmd-V di Mac) untuk menambahkan lampiran dari papan klip.',
      project: 'Proyek',
      projectNotFound_title: 'Proyek Tidak Ditemukan',
      removeManager_title: 'Hapus Manager',
      removeMember_title: 'Hapus Anggota',
      searchLabels: 'Cari label...',
      searchMembers: 'Cari anggota...',
      searchUsers: 'Cari pengguna...',
      seconds: 'Detik',
      selectBoard: 'Pilih papan',
      selectList: 'Pilih daftar',
      selectPermissions_title: 'Pilih Izin',
      selectProject: 'Pilih proyek',
      settings: 'Setelan',
      stopwatch: 'Stopwatch',
      subscribeToMyOwnCardsByDefault: 'Berlangganan kartu saya sendiri secara default',
      taskActions_title: 'Aksi Tugas',
      tasks: 'Tugas',
      thereIsNoPreviewAvailableForThisAttachment:
        'Tidak ada pratinjau yang tersedia untuk lampiran ini.',
      time: 'Waktu',
      title: 'Judul',
      userActions_title: 'Aksi Pengguna',
      userAddedThisCardToList: '<0>{{user}}</0><1> menambahkan kartu ini ke {{list}}</1>',
      userLeftNewCommentToCard: '{{user}} mengomentari «{{comment}}» di <2>{{card}}</2>',
      userMovedCardFromListToList:
        '{{user}} memindahkan <2>{{card}}</2> dari {{fromList}} ke {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> memindahkan kartu ini dari {{fromList}} ke {{toList}}</1>',
      username: 'Username',
      usernameAlreadyInUse: 'Username telah digunakan',
      users: 'Pengguna',
      version: 'Versi',
      viewer: 'Penglihat',
      writeComment: 'Tuliskan komentar...',
    },

    action: {
      addAnotherCard: 'Tambahkan kartu lain',
      addAnotherList: 'Tambahkan daftar lain',
      addAnotherTask: 'Tambahkan aksi lain',
      addCard: 'Tambah kartu',
      addCard_title: 'Tambah Kartu',
      addComment: 'Tambah komentar',
      addList: 'Tambah daftar',
      addMember: 'Tambah anggota',
      addMoreDetailedDescription: 'Tambahkan deskripsi yang lebih detail',
      addTask: 'Tambah tugas',
      addToCard: 'Tambahkan ke kartu',
      addUser: 'Tambah pengguna',
      createBoard: 'Tambah papan',
      createFile: 'Tambah berkas',
      createLabel: 'Tambah label',
      createNewLabel: 'Tambah label baru',
      createProject: 'Tambah proyek',
      delete: 'Hapus',
      deleteAttachment: 'Hapus lampiran',
      deleteAvatar: 'Hapus avatar',
      deleteBoard: 'Hapus papan',
      deleteCard: 'Hapus kartu',
      deleteCard_title: 'Hapus Kartu',
      deleteComment: 'Hapus komentar',
      deleteImage: 'Hapus gambar',
      deleteLabel: 'Hapus labek',
      deleteList: 'Hapus daftar',
      deleteList_title: 'Hapus Daftar',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Hapus proyek',
      deleteProject_title: 'Hapus Proyek',
      deleteTask: 'Hapus tugas',
      deleteTask_title: 'Hapus Tugas',
      deleteUser: 'Hapus pengguna',
      edit: 'Ubah',
      editDueDate_title: 'Ubah Tenggat Waktu',
      editDescription_title: 'Ubdah Deskripsi',
      editEmail_title: 'Ubah E-mail',
      editInformation_title: 'Ubah Informasi',
      editPassword_title: 'Ubah Kata Sandi',
      editPermissions: 'Ubah izin',
      editStopwatch_title: 'Ubah Stopwatch',
      editTitle_title: 'Ubah Judul',
      editUsername_title: 'Ubah Username',
      hideDetails: 'Sembunyikan detail',
      import: 'Impor',
      leaveBoard: 'Keluar dari papan',
      leaveProject: 'Keluar dari proyek',
      logOut_title: 'Keluar',
      makeCover_title: 'Buat Cover',
      move: 'Pindah',
      moveCard_title: 'Pindahkan Kartu',
      remove: 'Hapus',
      removeBackground: 'Hapus latar belakang',
      removeCover_title: 'Hapus Cover',
      removeFromBoard: 'Hapus dari papan',
      removeFromProject: 'Hapus dari proyek',
      removeManager: 'Hapus manager',
      removeMember: 'Hapus papan',
      save: 'Simpan',
      showAllAttachments: 'Tampilkan semua lampiran ({{hidden}} tersembunyi)',
      showDetails: 'Tampilkan detail',
      showFewerAttachments: 'Tampilkan lampiran lebih sedikit',
      start: 'Mulai',
      stop: 'Berhenti',
      subscribe: 'Berlanggan',
      unsubscribe: 'Berhenti berlangganan',
      uploadNewAvatar: 'Unggah avatar baru',
      uploadNewImage: 'Unggah gambar baru',
    },
  },
};
